import { render, staticRenderFns } from "./NewTicket.vue?vue&type=template&id=108e6c03&scoped=true&"
import script from "./NewTicket.vue?vue&type=script&lang=js&"
export * from "./NewTicket.vue?vue&type=script&lang=js&"
import style0 from "./NewTicket.vue?vue&type=style&index=0&id=108e6c03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108e6c03",
  null
  
)

export default component.exports